import { cn } from '@/new/lib/utils';

export interface DayCell {
  date: Date;
  inMonth: boolean;
  inWindow: boolean;
  isStart: boolean;
  isResult: boolean;
  isSkippedWeekend: boolean;
  isSkippedHoliday: boolean;
  holidayName?: string;
  countPosition: number | null;
}

interface CalculatorCalendarCellProps {
  cell: DayCell;
  isSelected: boolean;
  onSelect: (date: Date) => void;
}

export function CalculatorCalendarCell({ cell, isSelected, onSelect }: CalculatorCalendarCellProps) {
  return (
    <button
      type="button"
      onClick={() => cell.inMonth && onSelect(cell.date)}
      disabled={!cell.inMonth}
      className={cn(
        'relative flex h-10 items-center justify-center rounded-md text-sm transition-colors',
        !cell.inMonth && 'invisible',
        cell.inMonth && !cell.inWindow && 'text-gray-400 hover:bg-gray-50',
        cell.isStart && 'bg-gray-900 font-medium text-white',
        cell.countPosition !== null && !cell.isResult && 'bg-violet-100 font-medium text-violet-700',
        cell.isSkippedWeekend && 'border border-gray-200 text-gray-400',
        cell.isSkippedHoliday && 'border border-rose-200 text-rose-400',
        cell.isResult && 'bg-teal-100 font-medium text-teal-700',
        isSelected && 'ring-2 ring-teal-600 ring-inset',
      )}
      title={cell.holidayName ?? undefined}
    >
      <span>{cell.date.getUTCDate()}</span>
      {cell.countPosition !== null && (
        <span className="absolute -top-1.5 -right-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-white px-1 text-[9px] font-semibold text-gray-700 shadow ring-1 ring-gray-200">
          {cell.countPosition}
        </span>
      )}
    </button>
  );
}
